export const ChronicleConstants = {
  'GET_CHRONICLE_REQUEST': 'GET_CHRONICLE_REQUEST',
  'GET_CHRONICLE_SUCCESS': 'GET_CHRONICLE_SUCCESS',
  'GET_CHRONICLE_FAILURE': 'GET_CHRONICLE_FAILURE',

  'SAVE_CHRONICLE_REQUEST': 'SAVE_CHRONICLE_REQUEST',
  'SAVE_CHRONICLE_SUCCESS': 'SAVE_CHRONICLE_SUCCESS',
  'SAVE_CHRONICLE_FAILURE': 'SAVE_CHRONICLE_FAILURE',

  'CREATE_CHRONICLE_CALENDAR_REQUEST': 'CREATE_CHRONICLE_CALENDAR_REQUEST',
  'CREATE_CHRONICLE_CALENDAR_SUCCESS': 'CREATE_CHRONICLE_CALENDAR_SUCCESS',
  'CREATE_CHRONICLE_CALENDAR_FAILURE': 'CREATE_CHRONICLE_CALENDAR_FAILURE',
}